<div class="form-group ">
  <div class="col-md-12 ">
    <label class="text-danger">{{response}}</label>
  </div>
</div>


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
  <p style="color: white">Please Wait. </p>  
  </ngx-spinner>